import AppRootContext from "context/app-context";
import RouteComponent from "routes";
window.Buffer = window.Buffer || require("buffer").Buffer;

const App = () => {
  return (
    <AppRootContext>
      <RouteComponent />
    </AppRootContext>
  );
};

export default App;
